import React, {useEffect, useState} from 'react';
import InputContainer from 'components/InputContainer';
import OutsideClickHandler from 'react-outside-click-handler';
import ClearIcon from 'assets/svgs/actions/clear.svg';
import messages from '../messages';

const Rename = ({onClose, file, onUpdate}) => {
  const [fileName, setFileName] = useState(null);

  useEffect(() => {
    setFileName(file.name);
  }, [file]);

  return (
    <div className="featured-img-popup">
      <div className="overlay"></div>

      <div className="box-popup d-flex justify-content-center align-items-center add-folder-container">
        <OutsideClickHandler
          onOutsideClick={() => {
            onClose();
          }}
        >
          <>
            <div className="content-popup small">
              <div className="d-flex w-100 flex-column p-4">
                <p>{messages.renameFolder}</p>
                <div>
                  <InputContainer
                    type="text"
                    value={fileName}
                    handleChange={(event) => {
                      setFileName(event.target.value);
                    }}
                    inputClass="form-control"
                  />
                </div>
                <div className="d-flex w-100 mt-2 justify-content-end">
                  <button
                    type="button"
                    className="cat-delete"
                    onClick={onClose}
                  >
                    <img src={ClearIcon} alt="" className="mr-2" />
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="ml-4 cat-delete"
                    onClick={() => {
                      if (fileName) {
                        onUpdate({
                          _id: file._id,
                          details: {name: fileName},
                          oldName: file.name,
                        });
                      }
                    }}
                  >
                    Rename folder
                  </button>
                </div>
              </div>
            </div>
          </>
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default Rename;
